import { useTranslation } from "react-i18next";
import { FieldProps } from "./FiltersBar";
import FiltersBarWithButton from "./FiltersBarWithButton";

type AppFiltersProps = {
  className: string;
  filters: { [key: string]: any };
  setFilters: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  onLoadMore?: (key: string) => void;
  fields: FieldProps[];
  handleButtonClick: Function;
  loadingBottomMargin?: number;
};
export default function AppFilters(props: AppFiltersProps) {
  const {
    className,
    filters,
    setFilters,
    onLoadMore = () => {},
    fields,
    handleButtonClick,
    loadingBottomMargin,
  } = props;

  const { t } = useTranslation("", { keyPrefix: "filter" });

  const DEFAULT_OPTION = { key: t("all"), value: "all" };

  // Extending fields options with a default option
  const fieldsWithExtendOptions = fields.map((field) => {
    return { ...field, options: [DEFAULT_OPTION, ...field.options] };
  });

  const _setFilters = (name: string, value: any) => {
    setFilters((f) => ({ ...f, [name]: value }));
  };

  const getFilterValue = (name: string) => {
    return filters[name] || DEFAULT_OPTION.value;
  };

  return (
    <FiltersBarWithButton
      wrapperClassName={className}
      handleButtonClick={handleButtonClick}
      buttonText={t("cancel")}
      setFilters={_setFilters}
      onLoadMore={(key: string) => onLoadMore(key)}
      fields={fieldsWithExtendOptions}
      getFilterValue={getFilterValue}
      loadingBottomMargin={loadingBottomMargin}
    />
  );
}
